// extracted by mini-css-extract-plugin
export var downArrow = "_g4-0";
export var infoTooltipIcon = "_g4-3";
export var label = "_g4-1";
export var optionCard = "_g4-4";
export var upArrow = "_g4-2";